/*
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-08-30 14:48:14
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-09-08 14:24:21
 */
export default {
    // Options.jsx
    items_per_page: 'Artikulo / Pahina',
    jump_to: 'Tumalon sa',
    jump_to_confirm: 'Oo naman',
    page: 'Pahina',
    // Pagination.jsx
    prev_page: 'Nakaraang pahina',
    next_page: 'Susunod na pahina',
    prev_5: 'Pumunta sa 5 pahina',
    next_5: 'Bumalik sa 5 pages',
    prev_3: 'Pumunta ng 3 pahina pasulong',
    next_3: 'Bumalik sa 3 pahina'
};